import { useEffect, useRef } from 'react';

// Triggers after each render except the first one
export const useUpdateEffect = (cb, deps) => {
    const isFirstRun = useRef(true);

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        return cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
